window.setCookie = function (name, value, days) {
  var expires = '';

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=".concat(date.toUTCString());
  }

  document.cookie = "".concat(name, "=").concat(value || '').concat(expires, "; path=/");
};

window.getCookie = function (name) {
  var nameEQ = "".concat(name, "=");
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
};

window.deleteCookie = function (name, path, domain) {
  if (window.getCookie(name)) {
    document.cookie = "".concat(name, "=").concat(path ? ";path=".concat(path) : "").concat(domain ? ";domain=".concat(domain) : "", ";expires=Thu, 01 Jan 1970 00:00:01 GMT");
  }
};

window.eraseCookie = function (name) {
  document.cookie = "".concat(name, "=; Max-Age=-99999999;");
};

window.Base64 = {
  decode: function decode(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
      return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
    }).join(''));
  },
  encode: function encode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(match, p1) {
      return String.fromCharCode("0x".concat(p1));
    }));
  }
};
window.discountSession = {
  setItem: function setItem(name, value) {
    var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
    window.setCookie(name, value, days);
  },
  getItem: function getItem(name) {
    return window.getCookie(name);
  },
  removeItem: function resetCookie(name) {
    this.setItem(name, null);
  }
};